import { IAppState } from '../../redux';

interface IDiffPricingIds {
  diffPriceIterationId: string | null;
  diffPriceGranuleGuid: string | null;
}

export const selectAnalyticsDiffPricingIds = (state: IAppState): IDiffPricingIds | null => {
  const { iterationId, granuleGuid } = state.publishTerms.diffPricing;

  if (!!iterationId || !!granuleGuid) {
    return {
      diffPriceIterationId: iterationId,
      diffPriceGranuleGuid: granuleGuid,
    };
  }

  return null;
};
